import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useNotificationsContext } from './NotificationsContext';
import { NotificationsService } from './Service';
import { baseURL } from '../AxiosConfig';
import { Bell } from 'lucide-react';

const service = new NotificationsService();

const formatTime = (createdAt: Date | string) => {
    const date = moment(createdAt);
    if (date.isSame(moment(), 'day')) return date.fromNow();
    if (date.isSame(moment().subtract(1, 'day'), 'day')) return date.format('HH:mm');
    return date.format(date.isSame(moment(), 'year') ? 'DD/MM' : 'DD/MM/YYYY');
};

export default function NotificationItem({ notification }: any) {
    const navigate = useNavigate();
    const { setDropdownOpen, loadNotifications } = useNotificationsContext();
    const [avatarFailed, setAvatarFailed] = useState(false);
    const unread = !notification.visualizedAt;
    const showAvatar = !!notification.createdBy && !avatarFailed;
    const interactive = unread || !!notification.path;

    const onClick = () => {
        if (unread) {
            service
                .view(notification._id)
                .then(() => loadNotifications())
                .catch((error) => console.error(error));
        }
        if (notification.path) {
            navigate(notification.path);
            setDropdownOpen(false);
        }
    };

    const content = (
        <>
            <span className="sf-thumb sf-notif-avatar">
                {showAvatar ? (
                    <img
                        src={`${baseURL}/users/profileImage/${notification.createdBy}`}
                        alt=""
                        onError={() => setAvatarFailed(true)}
                    />
                ) : (
                    <Bell aria-hidden="true" />
                )}
            </span>
            <span className="sf-row-body">
                <span className="sf-notif-top">
                    <span className="sf-row-title min-w-0">{notification.title}</span>
                    <time className="sf-notif-time" dateTime={moment(notification.createdAt).toISOString()}>
                        {formatTime(notification.createdAt)}
                    </time>
                </span>
                <span className="sf-notif-message">{notification.message}</span>
                {!!notification.imageId && (
                    <img
                        src={`${baseURL}/files/${notification.imageId}`}
                        alt="Imagem da mensagem"
                        className="sf-notif-image"
                        loading="lazy"
                    />
                )}
            </span>
        </>
    );

    const className = `sf-row sf-notif-row ${unread ? 'is-unread' : ''}`;

    return (
        <li>
            {interactive ? (
                <button type="button" className={className} onClick={onClick}>
                    {content}
                </button>
            ) : (
                <div className={className}>{content}</div>
            )}
        </li>
    );
}
